import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as THREE from 'three';
var OBBHelper = /*#__PURE__*/function (_THREE$Box3Helper) {
  _inherits(OBBHelper, _THREE$Box3Helper);
  var _super = _createSuper(OBBHelper);
  function OBBHelper(OBB, text, color) {
    var _this;
    _classCallCheck(this, OBBHelper);
    color = color || new THREE.Color(Math.random(), Math.random(), Math.random());
    _this = _super.call(this, OBB.box3D, color.getHex());
    _this.obb = OBB;
    _this.material.linewidth = 2;
    _this.frustumCulled = false;
    _this.matrixAutoUpdate = false;
    _this.rotationAutoUpdate = false;
    _this.updateMatrixWorld(true);
    return _this;
  }
  _createClass(OBBHelper, [{
    key: "updateMatrixWorld",
    value: function updateMatrixWorld() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.obb.box3D.isEmpty()) {
        return;
      }
      this.quaternion.copy(this.obb.quaternion);
      this.obb.box3D.getCenter(this.position).applyQuaternion(this.quaternion).add(this.obb.position);
      this.obb.box3D.getSize(this.scale);
      this.scale.multiplyScalar(0.5);
      this.updateMatrix();
      THREE.Object3D.prototype.updateMatrixWorld.call(this, force);
    }
  }]);
  return OBBHelper;
}(THREE.Box3Helper);
export default OBBHelper;